module.exports = __webpack_public_path__ + "624c1255/img/44000000-0.f94ae6cd.png";